import React, { useState } from 'react';
import './InfoLogin.css';
import api from '../api';
import { useNavigate } from 'react-router-dom';

const InfoLogin = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log('Username:', username);
    console.log('Password:', password);

    setError(''); // Reset error

    try {
      const response = await api.post('/confirmInfoLogin', {
        username: username,
        password: password,
      });

      if (response.data?.status?.statusCode === 'code-200'){
        navigate('/requests/requestInfo', { state: { fromLogin: true } });
      } else {
        setError('Incorrect credentials');
      }
    } catch (err) {
      setError('Something went wrong');
    }
  };

  return (
    <div className="login-container">
      <form className="login-form" onSubmit={handleSubmit}>
        <h2>Login</h2>
        <input
          type="text"
          placeholder="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          required
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        {error && <p className="error">{error}</p>}
        <button type="submit">Login</button>
      </form>
    </div>
  );
};

export default InfoLogin;
